const SESSION_KEY = 'INST_SYS_SET_CACHE'

const safeParse = (value, fallback) => {
  try {
    return JSON.parse(value)
  } catch (e) {
    return fallback
  }
}

const readMap = () => {
  const raw = sessionStorage.getItem(SESSION_KEY)
  if (!raw) return {}
  const parsed = safeParse(raw, {})
  return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
}

const writeMap = (map) => {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(map || {}))
}

const normalizeItems = (responseOrItems) => {
  if (Array.isArray(responseOrItems)) return responseOrItems
  if (Array.isArray(responseOrItems?.data?.items)) return responseOrItems.data.items
  if (Array.isArray(responseOrItems?.data)) return responseOrItems.data
  if (Array.isArray(responseOrItems?.items)) return responseOrItems.items
  return []
}

const buildMap = (items = []) =>
  items.reduce((acc, item) => {
    const key = item?.sysStngKey
    if (!key) return acc
    acc[key] = item?.sysStngVl ?? ''
    return acc
  }, {})

export const useInstSysSetSession = () => {
  // instId 파라미터는 하위 호환을 위해 유지하며 현재는 사용하지 않는다.
  const saveInstSysSetList = (_instId, responseOrItems) => {
    const items = normalizeItems(responseOrItems)
    writeMap(buildMap(items))
  }

  const getInstSysSetItems = (_instId) => []

  const getInstSysSetMap = (_instId) => readMap()

  const getInstSysSetValue = (_instId, sysStngKey, defaultValue = '') => {
    const map = readMap()
    return Object.prototype.hasOwnProperty.call(map, sysStngKey) ? map[sysStngKey] : defaultValue
  }

  const getInstSysSetUpdatedAt = (_instId) => 0

  const clearInstSysSet = (_instId) => {
    sessionStorage.removeItem(SESSION_KEY)
  }

  return {
    SESSION_KEY,
    saveInstSysSetList,
    getInstSysSetItems,
    getInstSysSetMap,
    getInstSysSetValue,
    getInstSysSetUpdatedAt,
    clearInstSysSet
  }
}

